import { createContext } from "react";

const ResourceContext = createContext()

export default ResourceContext